import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SITE_NAME, SITE_URL, SITEMAP_LASTMOD } from '../../constants/siteSeo';

type Props = {
  page: 'privacy' | 'terms';
};

/** Privacy / Terms 向け最小 JSON-LD（WebPage + BreadcrumbList） */
export default function LegalPageStructuredData({ page }: Props) {
  const { t } = useTranslation();
  const pageUrl = `${SITE_URL}/${page}`;
  const name = t(`${page}.title`);
  const description = t(`${page}.meta_description`);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name,
        description,
        dateModified: SITEMAP_LASTMOD,
        isPartOf: { '@id': `${SITE_URL}/#website` },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: SITE_NAME,
            item: SITE_URL,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name,
            item: pageUrl,
          },
        ],
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
